@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ciFundraising {
  border: 10px solid white;
  display: flex;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;

  &-text {
    width: 45%;
    padding: 0 2%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
  }

  &-heading {
    font-size: 40px;
    margin: 0;
    padding-bottom: $spacing-16;
  }

  &-buttons {
    display: flex;
    gap: 12px;
  }

  &-image {
    @include image('assets/header/fundraising_2x.jpg');
    border: 10px solid white;
    background-size: cover;
    flex: 1;
    margin: 15px 0;
  }
}
